const tutoUrls = {
  eleveVideoTutorialEmbedUrl: 'https://www.youtube.com/embed/aN8BHFagD84',
  eleveVideoTutorialUrl: 'https://www.youtube.com/watch?v=aN8BHFagD84',
  multiniveau: 'https://www.youtube.com/watch?v=rAe_tZ-CWQk',
  shareSchool: 'https://www.youtube.com/watch?v=cv40npXdZl4',
  programmationTutoUrl: 'https://www.youtube.com/watch?v=RbjU7OR9-jY',
  programmationTutoEmbedUrl: 'https://www.youtube.com/embed/RbjU7OR9-jY',
  referentiels: 'https://youtu.be/1ttrswFWmQw',
  importFichierEleve: 'https://www.youtube.com/watch?v=wSnZtrVujOY',
  presentationLsu: 'https://www.youtube.com/watch?v=t15RH1HaYAQ',
  eleveDocumentationAddEleves:
    'https://teetsh.com/documentation/eleves/#ajouter-vos-eleves-dans-teetsh',
};

/**
 * Build a youtube embed url with the correct language and subtitles
 * Only embed urls are supported ! https://stackoverflow.com/a/74328768/221236
 */
export function buildYoutubeEmbedUrl(
  url: string,
  opts: {
    lng: string;
    forceSubtitles?: boolean;
    autoplay?: boolean;
  },
) {
  if (!url.includes('youtube.com/embed')) {
    return url;
  }

  const params = new URLSearchParams();
  params.set('cc_lang_pref', opts.lng);
  if (opts.forceSubtitles) {
    params.set('cc_load_policy', '1');
  }
  if (opts.autoplay) {
    params.set('autoplay', '1');
  }
  return `${url}?${params.toString()}`;
}

export { tutoUrls };
